import React from "react";
import { IChat } from "../../../interfaces/chat";
import { readChat } from "../../../services/chat.service";
import { db } from "../../../services/firebaes.service";
interface Props {
  uid: string;
  startDate?: number | string | Date;
  imageUrl: string;
}

export default function useChatRoom(props: Props) {
  const [chats, setChats] = React.useState<IChat[]>([]);
  const [isLoading, setLoading] = React.useState<boolean>(true);
  const messagesEndRef = React.useRef(null);
  const scrollToBottom = () => {
    if (!messagesEndRef.current) return;
    //@ts-ignore
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };
  React.useEffect(scrollToBottom, []);
  React.useEffect(() => {
    if (!props.uid) return;
    const unsubscribe = db
      .collection("chats")
      .doc(props.uid)
      .collection("chat")
      .where(
        "timestamp",
        ">=",
        props.startDate
          ? new Date(props.startDate as string).getTime()
          : new Date("1971-01-01").getTime()
      )
      .orderBy("timestamp", "asc")
      .onSnapshot((snap) => {
        snap.docChanges().forEach((change, index) => {
          if (change.type === "added") {
            const chat = { ...change.doc.data(), id: change.doc.id } as IChat;
            setChats((chats) => [...chats, chat]);
            scrollToBottom();
            setLoading(false);
            if (
              props.uid &&
              !chat.doctorId &&
              index === snap.docChanges().length - 1
            )
              readChat(props.uid);
          }
        });
      });
    //remember to unsubscribe from your realtime listener on unmount or you will create a memory leak
    return () => {
      setChats([]);
      unsubscribe();
    };
  }, [props.uid, props.startDate]);
  return { isLoading, chats, messagesEndRef };
}
